import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, Divider, FormControl, Grid, IconButton, MenuItem, Popover, Select, Stack, TextField, Typography } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon, DotIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import { format, isValid, parse } from 'date-fns';
import { ApiGetBundleList, ApiDeleteBundleAllocation, ApiGetShopperList, ApiGetVisitTimes, ApiBulkAssignShopper, ApiCreateBundleAllocation, ApiAssignBulkAllocations, ApiChangeShopperOfBundle, ApiCreateCopyAllBundles, ApiGetClientEntityByClientGroupId, ApiInviteBundle, ApiGetAllocations } from '../../../apiService/Core/Apicall.tsx';
import { Link, useNavigate } from 'react-router-dom';
import edit from "../../../assets/images/editIcon.png";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store.ts';
import { useDispatch } from 'react-redux';
import { setDate } from '../../../global/config/Reducer/dateSlice.ts';
import { AltRoute, CancelOutlined, Person2Outlined } from "@mui/icons-material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { endOfMonth, startOfMonth } from "date-fns"
import { LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from 'dayjs';
import { monthsData } from '../../../global/constants/globalContants.ts';
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts';
import Dcrage from '../OrphanAllocation/Dcrage.tsx';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';

function BundleAllocation() {

    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch();
    const [task, settask] = React.useState<any>([]);
    const [currentDate, setCurrentDate] = useState(() => {
        const date = new Date(selectedDateRedux);
        date.setMonth(date.getMonth());
        return date;
    }); const [reportMonth, setReportMonth] = useState<number>(currentDate.getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(currentDate.getFullYear());
    const [open, setOpen] = useState(false);
    const [openInviteShopper, setOpenInviteShopper] = useState(false);
    const [copybundle, setCopyBundle] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date | null>();
    const [shopperlist, setshopperlist] = useState([]);
    const [selectedShopper, setSelectedShopper] = useState<any>();
    const [searchShopper, setsearchShopper] = useState<any>([]);
    const [visitTimes, setVisitTimes] = useState<any[]>([]);
    const [visitTimesValues, setVisitTimesValues] = useState<any[]>([]);
    const [selectedAllocations, setSelectedAllocations] = useState<string[]>([]);
    const [selectedCopyAllocations, setSelectedCopyAllocations] = useState<any[]>([]);
    const [monthly, setMonthly] = useState([])
    const Navigate = useNavigate()
    const [selectedbundle, setselectedbundle] = useState<any>([])
    const [selectedbundleClinetEntity, setselectedbundlecliententity] = useState<any>('')
    const [assignData, setAssignData] = useState<any[]>([])
    const [openChangeShopper, setopenChangeShopper] = useState(false);
    const [selectedBundles, setSelectedBundles] = useState<any[]>([]);
    const [openCopyAllDialog, setOpenCopyAllDialog] = useState(false);
    const [copyAllMonths, setCopyAllMonths] = useState<number[]>([]);
    const [showCopyToAll, setShowCopyToAll] = useState(true);
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [ClientId, setClientId] = useState(null)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const selectedMonthStart = startOfMonth(new Date(reportYear, reportMonth - 1));
    const selectedMonthEnd = endOfMonth(new Date(reportYear, reportMonth - 1));

    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            dispatch(setDate(newDate))
            return newDate;
        });
    };
    const ApiBundleAllocation = async () => {
        settask([])
        let data = `?jobMonth=${reportMonth}&jobYear=${reportYear}`
        if (selectedClient?.clientGroupName) data += `&clientGroupName=${selectedClient.clientGroupName}`
        if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
        try {
            const response = await ApiGetBundleList(data)
            settask(response.data)

        } catch (error) {

            alert(error)
        }

    }

    useEffect(() => {
        ApiBundleAllocation()
    }, [reportMonth, reportYear, selectedClient, clientEntityId])

    const handleNextMonth = () => {

        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            dispatch(setDate(newDate))
            return newDate;
        });

    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");

        setCurrentDate(newDate);
        setReportMonth(newDate.getMonth() + 1);
        setReportYear(newDate.getFullYear());
        dispatch(setDate(event.target.value))

    };

    const deleteBundle = async (bundleId: number, newStatus: string) => {
        try {
            const data = `?bundleId=${bundleId}`
            const response: any = await ApiDeleteBundleAllocation(data);
            toast.success(response.message);
            ApiBundleAllocation()
        } catch (error: any) {
            console.error("Error during API call:", error);
            toast.error(error || "Something went wrong")
        }
    };

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])

    const handleCloseDialog = () => {
        setOpen(false)
        setVisitTimesValues([]);
        setSelectedShopper(null)
        setSelectedDate(new Date());
        setShowCopyToAll(true);
        setAssignData([])
    }

    const getShopperList = async (text: any) => {
        setshopperlist([])
        try {
            const data = `?offset=0&limit=1000${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            const originonal = res.data
            setshopperlist(originonal)
        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])
    const handleGetVisitTimeList = async () => {
        try {
            const response: any = await ApiGetVisitTimes();
            setVisitTimes(response.data);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };
    useEffect(() => {
        handleGetVisitTimeList()
    }, [])
    const handleBulkAssign = async () => {
        try {
            for (let i = 0; i < assignData.length; i++) {
                const item = assignData[i];

                if (!item.allocationId) {
                    toast.error(`Allocation ID missing at row ${i + 1}`);
                    return;
                }

                if (!item.selectedVisitDate) {
                    toast.error(`Visit Date missing for venue ${i + 1}`);
                    return;
                }

                if (!item.selectedVisitTime) {
                    toast.error(`Visit Time missing for venue ${i + 1}`);
                    return;
                }

                if (!item.userId) {
                    toast.error(`Shopper not selected for venue ${i + 1}`);
                    return;
                }
            }
            const data = {
                AllocationDetails: assignData.map((item: any) => ({
                    ...item,
                    selectedVisitDate: item.selectedVisitDate
                        ? (() => {
                            const [day, month, year] = item.selectedVisitDate.split("/");
                            return `${year}-${month}-${day}`;
                        })()
                        : null
                }))
            };
            console.log("Assign data", data)
            const response = await ApiAssignBulkAllocations(data);
            toast.success(response.message)
            setOpen(false)
            setselectedbundle([])
            setSelectedAllocations([]);
            setVisitTimesValues([]);
            setSelectedShopper(null)
            setSelectedDate(new Date());
            ApiBundleAllocation();
        } catch (error) {
            console.error("Error Assigning Shopper.", error);
            toast.error("Error Assigning Shopper.")
        }
    }

    const createCopyBundle = async () => {
        if (monthly?.length > 0) {
            try {
                const data = {
                    bundleName: selectedbundle,
                    months: monthly,
                    year: reportYear,
                    clientEntityId: selectedbundleClinetEntity,
                    allocations: selectedCopyAllocations,
                    clientGroupName: selectedClient?.clientGroupName
                }
                const response = await ApiCreateBundleAllocation(data);
                if (response.status) {
                    setSelectedCopyAllocations([])
                    setselectedbundle('')
                    setselectedbundlecliententity(null)
                    setCopyBundle(false)
                    ApiBundleAllocation()
                }
            } catch (error) {
                console.log("Error While Creting Error", error)
            }
            finally {
                setSelectedCopyAllocations([])
                setselectedbundle('')
                setMonthly([])
                setCopyBundle(false)
            }

        }
        else {
            alert("Please select month to copy bundle")
        }
    }
    const handleShopperChange = async () => {
        try {

            // const data = `?userId=${selectedShopper.userId}&bundleId=${selectedBundleId}`
            const data = {
                allocationIds: selectedbundle?.venue?.map((item: any) => item?.allocationId),
                userId: selectedShopper.userId
            }
            console.log("Data", data)
            const res = await ApiChangeShopperOfBundle(data)
            toast.success(res.message);
            setselectedbundle([])
            setSelectedShopper(null)
            setopenChangeShopper(false)
            ApiBundleAllocation()
        } catch (error) {
            console.error("Error Changing Shopper", error)
            toast.error("Error Changing Shopper.")
        }
    }
    const handleSelectBundle = (bundle: any, isChecked: boolean) => {
        if (isChecked) {
            setSelectedBundles(prev => [...prev, bundle]);
        } else {
            setSelectedBundles(prev => prev.filter(b => b.bundleId !== bundle.bundleId));
        }
    };

    const handleSelectAllBundles = (isChecked: boolean) => {
        if (isChecked) {
            setSelectedBundles(task);
        } else {
            setSelectedBundles([]);
        }
    };

    const checkIfSameClientEntity = (allocations: any[]) => {
        if (allocations.length === 0) return null;

        const getEntityId = (item: any) => {
            if (typeof item?.clientEntityId === 'number') {
                return item.clientEntityId;
            }
            if (typeof item?.clientEntityId === 'object' && item?.clientEntityId?.clientEntityId) {
                return item.clientEntityId.clientEntityId;
            }
            return null;
        };

        const firstClientEntityId = getEntityId(allocations[0]);

        if (!firstClientEntityId) return null;

        const allSame = allocations.every(
            (allocation) => getEntityId(allocation) === firstClientEntityId
        );

        return allSame ? firstClientEntityId : null;
    };

    const createCopyAllBundles = async () => {
        if (copyAllMonths?.length === 0) {
            alert("Please select month to copy bundles");
            return;
        }

        if (selectedBundles?.length === 0) {
            alert("Please select at least one bundle");
            return;
        }
        try {
            // const bundlesData = selectedBundles.map(bundle => ({
            //     bundleName: bundle.bundleName,
            //     months: copyAllMonths,
            //     year: reportYear,
            //     clientGroupName: selectedClient?.clientGroupName,
            //     allocations: bundle.venue.map((v: any) => ({
            //         venueIds: String(v.venueId)
            //     }))
            // }));
            const bundlesData = selectedBundles.map(bundle => {

                // calculate clientEntityId for each bundle separately
                const commonClientEntityId = checkIfSameClientEntity(bundle);

                return {
                    bundleName: bundle.bundleName,
                    months: copyAllMonths,
                    year: reportYear,
                    clientGroupName: selectedClient?.clientGroupName,
                    clientEntityId: bundle.clientEntityId,
                    allocations: bundle.venue.map((v: any) => ({
                        venueIds: String(v.venueId)
                    }))
                };
            });


            const data = {
                bundles: bundlesData
            };
            // console.log("Send Dat--------->", data)
            const res = await ApiCreateCopyAllBundles(data);
            toast.success(res.message);
            setSelectedBundles([]);
            setCopyAllMonths([]);
            setOpenCopyAllDialog(false);
            ApiBundleAllocation();
        } catch (error) {
            toast.error("Error copying bundles");
        }
    };
    const handleCopyToAll = () => {
        if (!assignData[0]?.selectedVisitDate || !assignData[0]?.selectedVisitTime) {
            toast.error("Please select date and time for the first venue");
            return;
        }

        if (assignData.length > 0) {
            setAssignData((prev) =>
                prev.map((item, index) => ({
                    ...item,
                    selectedVisitDate: assignData[0].selectedVisitDate,
                    selectedVisitTime: assignData[0].selectedVisitTime,
                }))
            );
        }
    };
    const shouldShowCopyToAll = () => {
        return showCopyToAll && assignData.length > 1;
    };

    const handleInviteShopper = async (allocationId: any) => {
        try {
            const data = `?allocationId=${allocationId}`
            const res = await ApiGetAllocations(data)
            if (res?.status) {
                sessionStorage.setItem("inviteShopperState", JSON.stringify(res?.data[0]))
                const url = `/admin/allocations/Invite-Shopper`
                window.open(url, "_blank")
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    console.log("Selecte dBundle", selectedBundles)
    return (
        <Box className="w-100 p-2">
            <Box className='bg-white pt-3 border-10'>
                <Box sx={{ width: "100%" }}>
                    <Typography className="text-center fs-42">Bundle Allocations</Typography>
                    <Grid container className="justify-content-between d-flex align-items-center mt-3 mb-4 mb-md-3 p-2">
                        <Grid size={{ xs: 12, md: 'auto' }} sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }} gap={2}>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={Clientlist}
                                    value={selectedClient}
                                    getOptionLabel={(option: any) => option?.clientGroupName}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.clientGroupDBName === value.clientGroupDBName
                                    }
                                    onChange={(event, newValue: any) => {
                                        // setSelectedClient(newValue)
                                        dispatch(setSelectedClientGroup(newValue))
                                        setClientId(newValue?.clientGroupName || null)
                                        setClientEntityId(null)
                                        setClientEntityList([])
                                    }}
                                    defaultValue="mmcommon"
                                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                                    size="small"
                                />
                            </FormControl>
                            <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                <Autocomplete
                                    disablePortal
                                    id="beacon-autocomplete"
                                    options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                                    getOptionLabel={(option) => option?.entityName || ""}
                                    onChange={(event, newValue: any) => {
                                        setClientEntityId(newValue?.clientEntityId || null)
                                    }}
                                    value={clientEntityList?.find((option) => option?.clientEntityId === clientEntityId) || null}
                                    renderInput={(params) => <TextField {...params} label="Select Business" />}
                                    size="small"
                                />
                            </FormControl>
                        </Grid>
                        {/* <Box className='col-6 d-flex juastify-content-start'> */}
                        <Grid size={{ xs: 12, md: 'auto' }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    // marginTop: "20px"
                                }}
                            >
                                <IconButton onClick={handlePrevMonth}>
                                    <ChevronLeftIcon />
                                </IconButton>
                                <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                                    <input
                                        type="month"
                                        onChange={handleDateChange}
                                        value={format(currentDate, "yyyy-MM")}
                                        className="primary-color"
                                        style={{
                                            border: "none",
                                            background: "none",
                                            fontSize: "1.25rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            fontFamily: "inherit",
                                        }}
                                    />
                                </Box>
                                <IconButton onClick={handleNextMonth}>
                                    <ChevronRightIcon />
                                </IconButton>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 'auto' }}>
                            <Box className='extra d-flex justify-content-end' gap={2}>
                                <Checkbox
                                    checked={selectedBundles.length === task.length && task.length > 0}
                                    indeterminate={selectedBundles.length > 0 && selectedBundles.length < task.length}
                                    onChange={(e) => handleSelectAllBundles(e.target.checked)}
                                    sx={{
                                        color: "#888",
                                        "&.Mui-checked": {
                                            color: "#888",
                                        },
                                        "& .MuiSvgIcon-root": {
                                            color: "#888",
                                        },
                                        "&.Mui-checked .MuiSvgIcon-root": {
                                            color: "#1976d2",
                                        }
                                    }}
                                />
                                <Typography className='d-flex align-items-center' variant='subtitle2' fontWeight={600}>
                                    Select All Bundles
                                </Typography>
                                <Button
                                    className="bg-grey transform px-4 text-light"
                                    onClick={() => setOpenCopyAllDialog(true)}
                                >
                                    Copy All Bundle
                                </Button>
                                <Link
                                    to={`/admin/allocations/createbundle-allocations`}
                                    className="link-btn px-5"
                                // onClick={() => { Navigate('/admin/allocations/createbundle-allocations') }}
                                >
                                    Create
                                </Link>
                            </Box>
                        </Grid>
                    </Grid>
                    <Divider className='mx-4 mb-2' />
                    <Box minHeight='calc(100vh - 380px)' className='w-100'>
                        <Grid container className='p-3 w-100 gap-2' alignItems={'stretch'}>
                            {task.map((item: any) => {
                                const uniqueUsers = [
                                    ...new Map(
                                        item.venue
                                            .filter((v: any) => v.user) // 👈 remove null users first
                                            .map((v: any) => [v.user.userId, v.user])
                                    ).values()
                                ];
                                return (
                                    <Grid size={{ xs: 12, md: 6 }} className='p-2' >
                                        <Box className='border w-100 d-flex p-0 p-md-3  h-100' sx={{ borderRadius: '10px' }} key={item.bundleId}>
                                            <Box className='d-flex align-items-start pt-3 ps-2'>
                                                <Checkbox
                                                    checked={selectedBundles.some(b => b.bundleId === item.bundleId)}
                                                    onChange={(e) => handleSelectBundle(item, e.target.checked)}

                                                />
                                            </Box>
                                            <Box className='p-2  d-flex h-100 w-100 px-0 flex-wrap'>
                                                <Box className="d-flex col-md-9 col-12 p-2" height="fit-content" flexDirection={"column"} gap={2}>
                                                    <Typography lineHeight='1.2' fontWeight='bold' className='m-0 p-0' sx={{
                                                        maxWidth: "100%",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "anywhere",
                                                        whiteSpace: "normal",
                                                    }}
                                                        variant='h6'>{item.bundleName}</Typography>
                                                    <Box className="d-flex" flex={1}>
                                                        <Typography fontWeight={700} variant='subtitle2'>Site:&nbsp;</Typography>
                                                        <ul className='mt-1 w-100 d-flex flex-wrap'>
                                                            {item?.venue?.map((items: any, index: number) => (
                                                                <li className='d-flex col-6 col-md-4'><span><DotIcon /></span><Typography whiteSpace='wrap' key={index} className='fw-bold m-0 p-0' variant='subtitle2'>{items.venueName}</Typography></li>
                                                            ))}
                                                        </ul>
                                                    </Box>
                                                    {uniqueUsers?.map((shopper: any) => (
                                                        <Box gap={1} className='d-flex align-items-center mt-2 mb-1' width="fit-content" sx={{ cursor: "pointer" }}
                                                            onClick={(e) => {
                                                                if (shopper?.userId) {
                                                                    // handleShopperDetailsClick(e, item?.venue[0]?.user?.userId)
                                                                    handleShopperDetailsClick(e, shopper?.userId)
                                                                }
                                                            }}
                                                        >
                                                            <Person2Outlined />
                                                            <Typography variant='body1' className={shopper?.userStatus !== "active" ? "px-2 bg-danger text-white" : ""}>{shopper?.firstName} {shopper?.lastName}</Typography>
                                                        </Box>
                                                    ))}
                                                </Box>
                                                <Popover
                                                    // open={Boolean(anchorEl) && selectedIndex === index}
                                                    open={Boolean(anchorEl) && clickedShopperId !== null}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "center",
                                                    }}
                                                    transformOrigin={{
                                                        vertical: "top",
                                                        horizontal: "center",
                                                    }}
                                                >
                                                    <Dcrage handleClose={handleClose} loanData={loanData} />
                                                </Popover>
                                                <Box className='d-flex col-md-3  col-12 px-0 w-100' justifyContent={'center'} flexWrap={'wrap'} gap={2} flex={1} flexDirection={{ xs: "row", md: "column" }}>
                                                    {item?.venue?.some(
                                                        (v: any) =>
                                                            v?.user === null
                                                    ) && (<Button
                                                        variant='contained'
                                                        color='primary'
                                                        fullWidth
                                                        className='table-row-background'
                                                        onClick={() => {
                                                            const allocations = item.venue
                                                                .filter((v: any) => v?.user === null)
                                                                .map((v: any) => v.allocationId)
                                                                .filter((id: any) => id !== null);

                                                            setSelectedAllocations(allocations);
                                                            setOpen(true)
                                                            setselectedbundle(item)
                                                            setShowCopyToAll(true);
                                                            setAssignData(
                                                                item?.venue?.filter((v: any) => v?.user === null)?.map((v: any) => ({
                                                                    allocationId: v.allocationId,
                                                                    selectedVisitDate: null,
                                                                    selectedVisitTime: null,
                                                                    userId: null,
                                                                }))
                                                            );
                                                        }}
                                                    >
                                                        Assign Shopper
                                                    </Button>
                                                        )}
                                                    {Array.isArray(item?.venue) &&
                                                        item.venue.length > 0 &&
                                                        item?.venue?.some((v: any) => v?.statusCode !== "completed") &&
                                                        item?.venue?.some((v: any) => v?.user?.userId) &&
                                                        (
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                fullWidth
                                                                className="table-row-background"
                                                                onClick={() => {
                                                                    setopenChangeShopper(true);
                                                                    setselectedbundle(item);
                                                                    setSelectedShopper(null);
                                                                }}
                                                            >
                                                                Change Shopper
                                                            </Button>
                                                        )}
                                                    <Button
                                                        variant='contained'
                                                        color='primary'
                                                        className='table-row-background'
                                                        onClick={() => {
                                                            const allocations = item.venue.map((v: any) => ({
                                                                venueIds: String(v.venueId)
                                                            }));
                                                            setselectedbundle(item.bundleName)
                                                            setselectedbundlecliententity(item?.clientEntityId)
                                                            setSelectedCopyAllocations(allocations)
                                                            setCopyBundle(true)
                                                        }}
                                                    >
                                                        Copy Bundle
                                                    </Button>
                                                    <Link
                                                        to={`/admin/allocations/createbundle-allocations/${currentDate}/${item?.bundleId}`}
                                                        // variant='contained'
                                                        // color='primary'
                                                        className='table-row-background text-center link-btn'
                                                    // onClick={() => { Navigate('/admin/allocations/createbundle-allocations', { state: { bundleData: item, currentDate: currentDate } }) }}
                                                    >
                                                        Edit Bundle
                                                    </Link>
                                                    <Link
                                                        to={`/admin/allocations/Invite-Shopper/${item?.venue[0]?.allocationId}`}
                                                        // variant='contained'
                                                        // color='primary'
                                                        className='table-row-background link-btn text-center'
                                                    // onClick={() => {
                                                    //     handleInviteShopper(item?.venue[0]?.allocationId)
                                                    // }}
                                                    >
                                                        Invite Shopper
                                                    </Link>
                                                    <Button

                                                        variant="outlined"
                                                        fullWidth
                                                        sx={{ background: "#FF00001A", color: "#FF0000", borderColor: "#FF0000" }}
                                                        onClick={() => {
                                                            const isConfirmed = window.confirm(
                                                                "Are you sure you want to delete the bundle?"
                                                            );
                                                            if (isConfirmed) {
                                                                deleteBundle(item.bundleId, "delete")
                                                            }
                                                        }}
                                                    >
                                                        Delete Bundle
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Box>
                    <Dialog open={open} maxWidth="sm" fullWidth>
                        <DialogContent sx={{ height: "fit-content", maxHeight: '' }}>
                            <Box display="flex" alignItems={'center'} justifyContent="space-between">
                                <Typography>{selectedbundle?.bundleName}</Typography>
                                <IconButton onClick={() => handleCloseDialog()}>
                                    <CancelOutlined />
                                </IconButton>
                            </Box>

                            <Autocomplete
                                id="shopper-autocomplete"
                                disablePortal
                                className='mt-3'
                                options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                                value={selectedShopper}
                                onInputChange={(event, newInputValue) => {
                                    setsearchShopper(newInputValue);
                                    if (newInputValue === "") setSelectedShopper(null);
                                }}
                                getOptionLabel={(option: any) =>
                                    `${option?.firstName} ${option?.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                                }
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option.userId === value.userId || option.emailId === value.emailId
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedShopper(newValue);
                                    setAssignData((prev) =>
                                        prev.map((item) => ({
                                            ...item,
                                            userId: newValue?.userId,
                                        }))
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Shopper" size="medium" fullWidth />
                                )}
                            />
                            {selectedbundle?.venue?.filter((v: any) => v?.user === null)?.map((item: any, index: number) => (
                                <Stack alignItems="stretch" className='mt-3'>
                                    <Typography gutterBottom fontWeight={'bold'}>{item?.venueName}</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Visit Date"
                                            className='mt-2'
                                            value={
                                                assignData[index]?.selectedVisitDate
                                                    ? (() => {
                                                        const parsedDate = parse(
                                                            assignData[index].selectedVisitDate,
                                                            "dd/MM/yyyy",
                                                            new Date()
                                                        );

                                                        return isValid(parsedDate) ? parsedDate : null;
                                                    })()
                                                    : null
                                            }
                                            minDate={selectedMonthStart}
                                            maxDate={selectedMonthEnd}
                                            // onChange={(newDate) => {
                                            //     const formattedDate = newDate
                                            //         ? format(new Date(newDate), "dd/MM/YYYY")
                                            //         : null;

                                            //     setAssignData((prev) =>
                                            //         prev.map((d, i) =>
                                            //             i === index
                                            //                 ? { ...d, selectedVisitDate: formattedDate }
                                            //                 : d
                                            //         )
                                            //     );
                                            //     if (index === 0) {
                                            //         setShowCopyToAll(true);
                                            //     }
                                            // }}
                                            onChange={(newDate) => {
                                                const isValidDate = newDate && !isNaN(new Date(newDate).getTime());
                                                console.log("New Data", newDate)

                                                const formattedDate = isValidDate
                                                    ? format(new Date(newDate), "dd/MM/yyyy")
                                                    : null;
                                                setAssignData((prev) =>
                                                    prev.map((d, i) =>
                                                        i === index
                                                            ? { ...d, selectedVisitDate: formattedDate }
                                                            : d
                                                    )
                                                );

                                                if (index === 0 && formattedDate) {
                                                    setShowCopyToAll(true);
                                                }
                                            }}
                                            format="dd/MM/yyyy"
                                            slotProps={{
                                                textField: {
                                                    size: "medium",
                                                    fullWidth: true,
                                                    // error: false,
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <Autocomplete
                                        options={visitTimes}
                                        disableCloseOnSelect
                                        className='mt-2'
                                        getOptionLabel={(option) => option.visitTimeInformation}
                                        value={
                                            visitTimes.find(
                                                (t) => t.visitTimeId.toString() === assignData[index]?.selectedVisitTime
                                            ) || null
                                        }
                                        // onChange={(event, newValue) => {
                                        //     setVisitTimesValues(
                                        //         newValue.map((item) => item.visitTimeId.toString())
                                        //     );
                                        // }}
                                        onChange={(event, newValue) => {
                                            setAssignData((prev) =>
                                                prev.map((d, i) =>
                                                    i === index
                                                        ? {
                                                            ...d,
                                                            selectedVisitTime: newValue
                                                                ? newValue.visitTimeId.toString()
                                                                : null,
                                                        }
                                                        : d
                                                )
                                            );
                                            if (index === 0) {
                                                setShowCopyToAll(true);
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                {option.visitTimeInformation}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Visit Times" size="medium" fullWidth />
                                        )}
                                    />
                                </Stack>
                            ))}

                        </DialogContent>

                        <DialogActions>
                            {shouldShowCopyToAll() && (
                                <Button
                                    variant="outlined"
                                    color="#ADB792"
                                    size="small"
                                    className="p-3"
                                    onClick={handleCopyToAll}
                                >
                                    Copy to All
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background p-3"
                                onClick={() => {
                                    const isConfirmed = window.confirm("Are You Sure You Want Assign Shopper ?")
                                    if (isConfirmed) {
                                        handleBulkAssign()
                                    }
                                }}
                            >
                                Assign Shopper
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={openInviteShopper} maxWidth="sm" fullWidth>
                        <DialogContent sx={{ height: "500px", maxHeight: '' }}>
                            <Box display="flex" alignItems={'center'} justifyContent="space-between">
                                <Typography>{selectedbundle?.bundleName}</Typography>
                                <IconButton onClick={() => {
                                    setselectedbundle([])
                                    setOpenInviteShopper(false)
                                    setSelectedShopper([])
                                }}>
                                    <CancelOutlined />
                                </IconButton>
                            </Box>

                            <Autocomplete
                                id="shopper-autocomplete"
                                disablePortal
                                className='mt-3'
                                options={shopperlist?.filter((item: any) => item?.firstName !== "") ?? []}
                                value={selectedShopper}
                                multiple
                                onInputChange={(event, newInputValue) => {
                                    setsearchShopper(newInputValue);
                                    if (newInputValue === "") setSelectedShopper([]);
                                }}
                                getOptionLabel={(option: any) =>
                                    `${option?.firstName} ${option?.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                                }
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option.userId === value.userId || option.emailId === value.emailId
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedShopper(newValue);
                                    setAssignData((prev) =>
                                        prev.map((item) => ({
                                            ...item,
                                            userId: newValue.userId,
                                        }))
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Shopper" size="medium" fullWidth />
                                )}
                            />
                        </DialogContent>

                        <DialogActions>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background p-3"
                                onClick={() => {
                                    const isConfirmed = window.confirm("Are You Sure You Want Invite Shopper ?")
                                    if (isConfirmed) {
                                        // handleInviteShopper()
                                    }
                                }}
                            >
                                Invite Shopper
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={openChangeShopper} maxWidth="sm" fullWidth>
                        <DialogContent sx={{ height: "150px" }}>
                            <Box display="flex" alignItems={'center'} justifyContent="space-between">
                                <Typography variant='h6'>{selectedbundle?.bundleName}</Typography>
                                <IconButton onClick={() => {
                                    setselectedbundle([])
                                    setSelectedShopper([])
                                    setopenChangeShopper(false)
                                }}>
                                    <CancelOutlined />
                                </IconButton>
                            </Box>
                            <Stack alignItems="stretch" mt={3}>
                                <Autocomplete
                                    id="shopper-autocomplete"
                                    // disablePortal
                                    options={shopperlist?.filter((item: any) => item?.firstName !== "")}
                                    value={selectedShopper ?? null}
                                    onInputChange={(event, newInputValue) => {
                                        setsearchShopper(newInputValue);
                                        if (newInputValue === "") setSelectedShopper(null);
                                    }}
                                    getOptionLabel={(option: any) =>
                                        `${option?.firstName} ${option?.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                                    }
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.userId === value.userId || option.emailId === value.emailId
                                    }
                                    onChange={(event, newValue: any) => setSelectedShopper(newValue)}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Shopper" size="medium" fullWidth />
                                    )}
                                />
                            </Stack>
                        </DialogContent>
                        <DialogActions className='mt-0'>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="table-row-background p-3"
                                onClick={() => {
                                    handleShopperChange()
                                }}
                            >
                                Change Shopper
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={copybundle}>
                        <DialogContent className='d-flex flex-column' sx={{ height: "fit-content", width: 'fit-content' }}>
                            <Box gap={5} className='d-flex align-items-center mb-3 justify-content-between'>
                                <Typography variant='h6' fontWeight={700}>{selectedbundle}</Typography>
                                <IconButton className='p-0 m-0' onClick={() => { setMonthly([]); setselectedbundlecliententity(null); setselectedbundle(''); setSelectedCopyAllocations([]); setCopyBundle(false) }}><CancelOutlined /></IconButton>
                            </Box>
                            <FormControl className='mx-auto' size="small" sx={{ minWidth: 150 }}>
                                <Select
                                    style={{ width: "150px" }}
                                    multiple
                                    value={monthly}
                                    displayEmpty
                                    onChange={(event: any) => {
                                        setMonthly(event.target.value)
                                    }}
                                    renderValue={(selected) =>
                                        selected.length === 0
                                            ? "Monthly"
                                            : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                                    }
                                >
                                    {monthsData.map((items) => (
                                        <MenuItem key={items.id} value={items.id}>
                                            {items.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                onClick={() => { createCopyBundle() }}
                                variant='contained'
                                color='primary'
                                className='table-row-background mt-2'>Copy</Button>
                        </DialogContent>
                    </Dialog>
                    <Dialog open={openCopyAllDialog}>
                        <DialogContent className='d-flex flex-column' sx={{ height: "fit-content", minWidth: 'fit-content' }}>
                            <Box gap={3} className='d-flex align-items-center mb-3 justify-content-between'>
                                <Typography variant='h6' fontWeight={700}>
                                    Copy Bundle{selectedBundles.length > 1 ? 's' : ''} - {selectedBundles.length}
                                </Typography>
                                <IconButton
                                    className='p-0 m-0'
                                    onClick={() => {
                                        setCopyAllMonths([]);
                                        setOpenCopyAllDialog(false);
                                    }}
                                >
                                    <CancelOutlined />
                                </IconButton>
                            </Box>

                            <Typography variant='body2' color='text.secondary' className='mb-3' sx={{ fontWeight: "bold" }}>
                                Selected Bundles: {selectedBundles.map(b => b.bundleName).join(', ')}
                            </Typography>

                            <FormControl className='mx-auto' size="small" sx={{ width: "100%" }}>
                                <Select
                                    multiple
                                    value={copyAllMonths}
                                    displayEmpty
                                    onChange={(event: any) => {
                                        setCopyAllMonths(event.target.value);
                                    }}
                                    renderValue={(selected) =>
                                        selected.length === 0
                                            ? "Select Months"
                                            : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                                    }
                                >
                                    {monthsData.map((items) => (
                                        <MenuItem key={items.id} value={items.id}>
                                            {items.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Button
                                onClick={() => { createCopyAllBundles() }}
                                variant='contained'
                                color='primary'
                                className='table-row-background mt-3'
                            >
                                Copy All Bundles
                            </Button>
                        </DialogContent>
                    </Dialog>
                </Box >
            </Box>
        </Box >
    )
}

export default BundleAllocation
